import NextImage from "next/image"
import { Component } from "@/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "image"

export const presets = {}

export interface Props extends Component {
  priority?: boolean
  height?: number
  width?: number
  src: null | string
  alt?: string
}

export function Image({
  priority,
  height,
  width,
  src,
  alt = "",
  className,
  testId = COMPONENT_NAME,
}: Props) {
  if (!src) return <div className={cx(`rounded bg-gray-200`, className)} data-test={testId} />
  return (
    <NextImage
      src={src}
      height={height}
      width={width}
      alt={alt}
      priority={priority}
      className={cx(`rounded bg-gray-200`, className)}
      data-test={testId}
    />
  )
}
